module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/payment-arrears/payment-arrears-grid/payment-arrears-grid.component.css
// module id = ./src/app/recovery/payment-arrears/payment-arrears-grid/payment-arrears-grid.component.css
// module chunks = main